module.exports = __webpack_public_path__ + "static/media/portfolio-alt.aa0e71f7.svg";